<template>
  <Layout>
    <LoadingData v-if="loadData" />
    <div v-else class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom"
      >
        <h5 class="card-title mb-0">Participantes</h5>
      </div>
      <div class="card-body">
        <ListUsers :users="users" />
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/Layout.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListUsers from '@/components/administration/users/ListUsers.vue'

export default {
  name: 'Users',

  components: {
    Layout,
    LoadingData,
    ListUsers,
  },

  data() {
    return {
      title: 'Participantes',
      items: [
        {
          text: 'Administração',
        },
        {
          text: 'participantes',
          active: true,
        },
      ],
      loadData: true,
      users: null,
    }
  },

  methods: {
    async getUsers() {
      try {
        this.users = await this.$store.dispatch('getUsers')
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
      }
    },
  },

  mounted() {
    this.getUsers()
  },
}
</script>
